<!-- pledge -->
<template>
  <div class="right" style="width:100%;overflow: hidden;">

    <rightTop @data="getCreditDataFn"></rightTop>


    <div class="rightCenter">
      <div class="centerTit">股权质押</div>
    </div>
    <div class="rightBottom">
      <!-- 第一套 -->
      <div class="tabulation">
        <div style="width:100%;overflow: hidden;margin-bottom:11px;">
          <div @click="downloadFn(0)" style="float:right;height: 18px;font-size:14px;cursor: pointer;overflow: hidden;margin-top:7px;margin-left:20px;">
            <img src="@/assets/img/Excel.png" alt style="display: inline-block;height: 18px;width:18px;float:left;" />
            <span style="display: inline-block;height: 18px;line-height: 18px;width:auto;vertical-align: middle;color:#3583ED;margin-left:4px;float:left;">下载数据到Excel</span>
          </div>
          <div style="display: inline-block;float:left;font-size:15px;font-weight:bold;height: 32px;vertical-align: middle;line-height: 32px;color: #fff;">质押比例</div>
        </div>
        <el-table :data="tableData1" :fit="true" border size="mini" :header-cell-style="cellStyle" style="width: 100%">
            <el-table-column width="60" :show-overflow-tooltip="true" label="序号">
              <template slot-scope="scope">
                {{scope.$index+1+(page1.currentPage-1)*page1.limit}} 
              </template>
            </el-table-column>
            <el-table-column min-width="100" :show-overflow-tooltip="true" prop="tdate" label="交易日期"></el-table-column>
            <el-table-column min-width="120" :show-overflow-tooltip="true" prop="amtshareratio" label="质押比例(%)">
              <template slot-scope="scope">
                <span>{{scope.row.amtshareratio | rounding}}</span>
              </template>
            </el-table-column>
            <el-table-column min-width="110" :show-overflow-tooltip="true" prop="bballowance" label="质押股数(万股)"></el-table-column>
            <el-table-column min-width="115" :show-overflow-tooltip="true" prop="zysz" label="质押市值(万元)"></el-table-column>
            <el-table-column min-width="95" :show-overflow-tooltip="true" prop="amtsharenum" label="质押笔数"></el-table-column>
            <el-table-column min-width="150" :show-overflow-tooltip="true" prop="bbyallowance" label="无限售股质押数(万股)"></el-table-column>
            <el-table-column min-width="130" :show-overflow-tooltip="true" prop="bbwallowance" label="限售股质押数(万股)"></el-table-column>
            <el-table-column min-width="140" :show-overflow-tooltip="true" prop="zdf" label="近一年涨跌幅(%)"></el-table-column>
            <el-table-column min-width="100" :show-overflow-tooltip="true" prop="hy" label="所属行业"></el-table-column>
        </el-table>
        <el-pagination
        	style="margin-top:20px;"
            prev-text="上一页"
            next-text="下一页"
            background
            :current-page="page1.currentPage"
            @current-change="handleCurrentChange1"
            :page-size="page1.limit"
            layout="total, prev, pager, next, jumper"
            :total="page1.total"
        ></el-pagination>
      </div>
      <!-- 第二套 -->
      <div class="tabulation" style="margin-top:41px;">
        <div style="width:100%;overflow: hidden;margin-bottom:11px;">
          <div @click="downloadFn(1)" style="float:right;height: 18px;font-size:14px;cursor: pointer;overflow: hidden;margin-top:7px;margin-left:20px;">
            <img src="@/assets/img/Excel.png" alt style="display: inline-block;height: 18px;width:18px;float:left;" />
            <span style="display: inline-block;height: 18px;line-height: 18px;width:auto;vertical-align: middle;color:#3583ED;margin-left:4px;float:left;">下载数据到Excel</span>
          </div>
          <div style="display: inline-block;float:left;font-size:15px;font-weight:bold;height: 32px;vertical-align: middle;line-height: 32px;color: #333333;">重要股东统计</div>
        </div>
        <el-table :data="tableData2" border size="mini" style="width: 100%">
          	<el-table-column width="60" :show-overflow-tooltip="true" label="序号">
              <template slot-scope="scope">
                {{scope.$index+1+(page2.currentPage-1)*page2.limit}} 
              </template>
            </el-table-column>
            <el-table-column min-width="140" :show-overflow-tooltip="true" prop="gdmc" label="股东名称"></el-table-column>
            <el-table-column min-width="140" :show-overflow-tooltip="true" prop="gdCount" label="最新质押笔数"></el-table-column>
            <el-table-column min-width="140" :show-overflow-tooltip="true" prop="amtsharefrozen" label="剩余质押股数(万股)"></el-table-column>
            <el-table-column min-width="160" :show-overflow-tooltip="true" prop="syscsz" label="剩余质押股份市值(万元)"></el-table-column>
            <el-table-column min-width="160" :show-overflow-tooltip="true" prop="syscbl" label="占所持股份比例(%)">
              <template slot-scope="scope">
                <span>{{scope.row.syscbl | rounding}}</span>
              </template>
            </el-table-column>
            <el-table-column min-width="140" :show-overflow-tooltip="true" prop="amtfrozenratio" label="占总股本比例(%)">
              <template slot-scope="scope">
                <span>{{scope.row.amtfrozenratio | rounding}}</span>
              </template>
            </el-table-column>
            <el-table-column min-width="140" :show-overflow-tooltip="true" prop="pcxMinPcxMax" label="平仓线区间(预估)"></el-table-column>
            <el-table-column min-width="140" :show-overflow-tooltip="true" prop="yjxMinYjxMax" label="预警线区间(预估)"></el-table-column>
            <el-table-column min-width="140" :show-overflow-tooltip="true" prop="updateDate" label="更新日期"></el-table-column>
        </el-table>
        <el-pagination
        	style="margin-top:20px;"
            prev-text="上一页"
            next-text="下一页"
            background
            :current-page="page2.currentPage"
            @current-change="handleCurrentChange2"
            :page-size="page2.limit"
            layout="total, prev, pager, next, jumper"
            :total="page2.total"
        ></el-pagination>
      </div>
      <!-- 第三套 -->
      <div class="tabulation" style="margin-top:41px;">
        <div style="width:100%;overflow: hidden;margin-bottom:11px;">
          <div @click="downloadFn(2)" style="float:right;height: 18px;font-size:14px;cursor: pointer;overflow: hidden;margin-top:7px;margin-left:20px;">
            <img src="@/assets/img/Excel.png" alt style="display: inline-block;height: 18px;width:18px;float:left;" />
            <span style="display: inline-block;height: 18px;line-height: 18px;width:auto;vertical-align: middle;color:#3583ED;margin-left:4px;float:left;">下载数据到Excel</span>
          </div>
          <div style="display: inline-block;float:left;font-size:15px;font-weight:bold;height: 32px;vertical-align: middle;line-height: 32px;color: #333333;">质押明细</div>
        </div>
        <el-table :data="tableData3" border size="mini" style="width: 100%" :fit="true">
          	<el-table-column width="60" :show-overflow-tooltip="true" label="序号">
              <template slot-scope="scope">
                {{scope.$index+1+(page3.currentPage-1)*page3.limit}} 
              </template>
            </el-table-column>
            <el-table-column width="140" :show-overflow-tooltip="true" prop="gdmc" label="股东名称"></el-table-column>
            <el-table-column width="140" :show-overflow-tooltip="true" prop="sharefrozennum" label="质押股份数量(万股)"></el-table-column>
            <el-table-column width="140" :show-overflow-tooltip="true" prop="sz" label="质押股份市值(万元)"></el-table-column>
            <el-table-column width="160" :show-overflow-tooltip="true" prop="frozenratio" label="占所持股份比例(%)">
              <template slot-scope="scope">
                <span>{{scope.row.frozenratio | rounding}}</span>
              </template>
            </el-table-column>
            <el-table-column width="140" :show-overflow-tooltip="true" prop="frozenintotal" label="占总股本比例(%)">
              <template slot-scope="scope">
                <span>{{scope.row.frozenintotal | rounding2}}</span>
              </template>
            </el-table-column>
            <el-table-column width="140" :show-overflow-tooltip="true" prop="jgmc" label="质押机构"></el-table-column>
            <el-table-column width="140" :show-overflow-tooltip="true" prop="frozenreason" label="质押原因"></el-table-column>
            <el-table-column width="140" :show-overflow-tooltip="true" prop="pledgepur" label="质押目的"></el-table-column>
            <el-table-column width="140" :show-overflow-tooltip="true" prop="spj" label="质押日收盘价(元)"></el-table-column>
            <el-table-column width="140" :show-overflow-tooltip="true" prop="yjx" label="预警线(估算)"></el-table-column>
            <el-table-column width="140" :show-overflow-tooltip="true" prop="pcx" label="平仓线(估算)"></el-table-column>
            <el-table-column width="140" :show-overflow-tooltip="true" prop="sdate" label="质押开始日期"></el-table-column>
            <el-table-column width="140" :show-overflow-tooltip="true" prop="enddate" label="质押解除日期"></el-table-column>
            <el-table-column width="140" :show-overflow-tooltip="true" prop="yjxPcxType" label="状态"></el-table-column>
            <el-table-column width="140" :show-overflow-tooltip="true" prop="ndate" label="公告日期"></el-table-column>
        </el-table>
        <el-pagination
        	style="margin-top:20px;"
            prev-text="上一页"
            next-text="下一页"
            background
            :current-page="page3.currentPage"
            @current-change="handleCurrentChange3"
            :page-size="page3.limit"
            layout="total, prev, pager, next, jumper"
            :total="page3.total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/../static/common/api/api.js";
import magic from "@/../static/common/magic.js";
import rightTop from "@/components/rightTop";
import $ from 'jquery';
export default {
  data() {
    return {
      tableData1:[],
      tableData2:[],
      tableData3:[],
      companyList:[],
      paramsData:{},//URL参数集合
      page1:{
      	currentPage:1,
      	limit:10,
      	total:0,
      	offset:0
      },
      page2:{
      	currentPage:1,
      	limit:10,
      	total:0,
      	offset:0
      },
      page3:{
      	currentPage:1,
      	limit:10,
      	total:0,
      	offset:0
      }
    };
  },
  components:{
    rightTop
  },
  filters: {
    rounding (value) {
      if(typeof value == "number"){
        if(value == 0){
          return value
        }else{
          return (value * 100).toFixed(2)
        }
        
      }else{
        return value
      }
    },
    rounding2 (value) {
      if(typeof value == "number"){
        if(value == 0){
          return value
        }else{
          return value.toFixed(2)
        }
        
      }else{
        return value
      }
    }
  },
  methods: {
  	// 分页函数
    handleCurrentChange1(val) {//当前页
        console.log(val,'vallll')
        this.page1.currentPage = val;
        this.page1.offset = (val-1)*this.page1.limit;
        this.fetchTable1(this.paramsData.stockCode,this.paramsData.enterpriseCode,this.page1.offset,this.page1.limit);
    },
    handleCurrentChange2(val) {//当前页
        this.page2.currentPage = val;
        this.page2.offset = (val-1)*this.page2.limit;
        this.fetchTable1(this.paramsData.stockCode,this.paramsData.enterpriseCode,this.page2.offset,this.page2.limit);
    },
    handleCurrentChange3(val) {//当前页
        this.page3.currentPage = val;
        this.page3.offset = (val-1)*this.page3.limit;
        this.fetchTable1(this.paramsData.stockCode,this.paramsData.enterpriseCode,this.page3.offset,this.page3.limit);
    },
  	//table的单元格样式
    cellStyle(row, column, rowIndex, columnIndex){
        
      return 'color: #333333;font-weight:bold;font-family:Microsoft YaHei;background:#F7F7F7;'
    },
    //收藏组件方法部分
    getCreditDataFn(data){
      console.log(data,'mytest')
      this.paramsData.stockCode = data[0].companyStockCode;
      this.paramsData.enterpriseCode = data[0].enterpriseCode;
      this.action();//获取表格数据
    },
    //下载函数
    downloadFn(incomeType){
      let _this = this;
      //收入类型分类 0:质押比例 1:重要股东统计 2:质押明细
      if(incomeType == 0){
        this.download(window.baseUrl + '/matters/downZyblData?stockCode=' + this.paramsData.stockCode + '&enterpriseCode=' + this.paramsData.enterpriseCode);
      }else if(incomeType == 1){
        this.download(window.baseUrl + '/matters/downZygdtjData?stockCode=' + this.paramsData.stockCode + '&enterpriseCode=' + this.paramsData.enterpriseCode);
      }else if(incomeType == 2){
        this.download(window.baseUrl + '/matters/downZymxData?stockCode=' + this.paramsData.stockCode + '&enterpriseCode=' + this.paramsData.enterpriseCode);
      }
      // 埋点
      try{
          //LogCollection.contents["key"]="value";
          //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
          //2：收藏
          //3：下载
          //4：分享
          //5：购买
          //6：登录
          //7：注册
          //9：搜索
          //10：复制
          //11：点赞
          //12：评论
          LogCollection.send(3);
      }catch(e){}
    },
    download(url) {
      let a = document.createElement('a');
      a.href = url;
      let _id = Math.random()+Math.random();
      a.id = _id;
      a.click();
      window.URL.revokeObjectURL(url);
    },
    action(){
      setTimeout(()=>{
        this.fetchTable1(this.paramsData.stockCode,this.paramsData.enterpriseCode,this.page1.offset,this.page1.limit);//按产品
        this.fetchTable2(this.paramsData.stockCode,this.paramsData.enterpriseCode,this.page2.offset,this.page2.limit);//按行业
        this.fetchTable3(this.paramsData.stockCode,this.paramsData.enterpriseCode,this.page3.offset,this.page3.limit);//按地域
        $('.el-table thead tr th').css({'background':'#F7F7F7','color':'#333','font-weight':'bold'});
      },900)
    },
    fetchTable1(stockCode, enterpriseCode, offset, limit){
      	let _this = this;
      	let _data = { 
	      	stockCode: stockCode,  
	      	enterpriseCode: enterpriseCode,  
	      	offset: offset,
	      	limit: limit
      	}
      	api.pledgeOne(_data).then(res=>{
	        let data = res.data.rows;
	        console.log(data,'data1');
	        _this.page1.total = res.data.total;
	        _this.tableData1 = data;
	        
      	})   
    },
    fetchTable2(stockCode, enterpriseCode, offset, limit){
      	let _this = this;
      	let _data = { 
	      	stockCode: stockCode,  
	      	enterpriseCode: enterpriseCode,  
	      	offset: offset,
	      	limit: limit
      	}
      	api.pledgeTwo(_data).then(res=>{
            let data = res.data.rows;
            console.log(data,'data2');
            _this.tableData2 = data;
            _this.page2.total = res.data.total;
      	})   
    },
    fetchTable3(stockCode, enterpriseCode, offset, limit){
      	let _this = this;
      	let _data = { 
	      	stockCode: stockCode,  
	      	enterpriseCode: enterpriseCode,  
	      	offset: offset,
	      	limit: limit
      	}
      	api.pledgeThree(_data).then(res=>{
          	let data = res.data.rows;
          	console.log(data,'data3');
          	_this.tableData3 = data;
          	_this.page3.total = res.data.total;
      	})   
    }
  },
  mounted() {
    
  }
};
</script>
<style scoped lang="less">
@import "../../assets/less/style.less";
.right {
  flex: 1;
  height: auto;
  margin-right: 23px;
  display: flex;
  flex-direction: column;
  .rightTop {
    width: auto;
    height: auto;
    margin-right: 20px;
    background: #ffffff;
    border-radius: 2px;
    display: flex;
    flex-direction: column;
    padding: 0 20px 10px;
    .title {
      height: 50px;
      line-height: 50px;
      border-bottom: 1px solid #dfdfdf;
      display: flex;
      justify-content: space-between;
      align-items: center;
      span {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333;
      }
      .button {
        width: 88px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background: #3583ed;
        border-radius: 2px;
        color: #fefefe;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
      }
    }
    .con {
      width: auto;
      flex: 1;
      font-size: 14px;
      font-family: Microsoft YaHei;
      color: #404040;
      display: flex;
      flex-direction: column;
      p {
        padding-top: 10px;
      }
    }
  }
  .rightCenter {
    width: auto;
    height: 61px;
    line-height: 61px;
    margin-right: 20px;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .centerTit {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: bold;
    }
    .centerCon {
      width: auto;
      height: 61px;
      line-height: 61px;
      display: flex;
      .no {
        span {
          display: inline-block;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333;
        }
      }
      .excel {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #3583ed;
        img {
          display: inline-block;
          width: 18px;
          height: 18px;
          transform: translate(0, 20%);
        }
      }
    }
  }
  .rightBottom {
    width: auto;
    height: auto;
    margin-right: 20px;
    margin-bottom: 40px;
    padding: 20px 20px 50px 20px;
    background: #fff;
    .tabulation {
      width: 100%;
      height: auto;
      // background: lightblue;
    }
  }
}
.mailTable, .mailTable tr, .mailTable tr td{ border:1px solid #08396A; }
.mailTable{ font-size: 14px; color: #4B4B4B; width:100%;font-family:Microsoft YaHei;}
.mailTable tr td{ border:1px solid #08396A; width: 80%; height: 35px; line-height: 35px; box-sizing: border-box; padding: 0 10px; color: #dfecf7; }
.mailTable tr td.column { background-color: #375572;  color: #dfecf7; font-size:14px;font-weight:bold;width:20%;}
.el-table thead{
  background-color: #F7F7F7!important; 
  color: #333333!important;
  font-size:14px!important;
  font-weight:bold!important;
}

</style>


// WEBPACK FOOTER //
// src/view/majorevents/pledge.vue